import { Outlet } from 'react-router-dom';
import { useState } from 'react';
import { usePlatformBranding } from '@/hooks/usePlatformBranding';
import { toRelativeUploadUrl } from '@/lib/utils';

export function AuthLayout() {
  const { logoUrl, appName } = usePlatformBranding(); // also sets favicon
  const resolvedLogoUrl = toRelativeUploadUrl(logoUrl);

  const [logoError, setLogoError] = useState(false);

  return (
    <div className="flex min-h-screen bg-gradient-to-br from-brand-50 via-white to-accent-50">
      {/* Left — branding (hidden on mobile, shown on lg+) */}
      <div className="hidden lg:flex lg:w-1/2 items-center justify-center">
        <div className="text-center">
          {resolvedLogoUrl && !logoError ? (
            <img
              src={resolvedLogoUrl}
              alt={appName}
              className="mx-auto h-28 w-28 rounded-3xl object-contain"
              style={{ boxShadow: 'var(--shadow-elevated)' }}
              onError={() => setLogoError(true)}
            />
          ) : (
            <div
              className="mx-auto flex h-28 w-28 items-center justify-center rounded-3xl bg-brand-600 text-white font-bold text-4xl"
              style={{ boxShadow: 'var(--shadow-elevated)' }}
            >
              {appName.charAt(0).toUpperCase()}
            </div>
          )}
          <h1 className="mt-6 text-3xl font-bold tracking-tight text-gray-900">
            {appName.toLowerCase()}
          </h1>
          <p className="mt-2 text-sm text-gray-500">
            Unified Safety &amp; Operations Platform
          </p>
        </div>
      </div>

      {/* Right — form card */}
      <div className="flex w-full items-center justify-center px-4 py-12 lg:w-1/2">
        <div className="w-full max-w-md">
          {/* Mobile-only branding (shown below lg) */}
          <div className="mb-8 text-center lg:hidden">
            {resolvedLogoUrl && !logoError ? (
              <img
                src={resolvedLogoUrl}
                alt={appName}
                className="mx-auto h-16 w-16 rounded-2xl object-contain"
                style={{ boxShadow: 'var(--shadow-elevated)' }}
                onError={() => setLogoError(true)}
              />
            ) : (
              <div
                className="mx-auto flex h-16 w-16 items-center justify-center rounded-2xl bg-brand-600 text-white font-bold text-2xl"
                style={{ boxShadow: 'var(--shadow-elevated)' }}
              >
                {appName.charAt(0).toUpperCase()}
              </div>
            )}
            <h1 className="mt-4 text-2xl font-bold text-gray-900">
              {appName.toLowerCase()}
            </h1>
            <p className="mt-1 text-sm text-gray-500">
              Unified Safety &amp; Operations Platform
            </p>
          </div>

          {/* Card */}
          <div className="rounded-2xl bg-white p-8" style={{ boxShadow: 'var(--shadow-elevated)' }}>
            <Outlet />
          </div>
        </div>
      </div>
    </div>
  );
}
